<template>
  <div class="pt-24 pb-20 md:pb-16 bg-white p-8 background--alt">
    <div class="container mx-auto text-left opacity-100 text-sm lg:px-4">
      <div
        class="flex flex-col justify-center items-start content-start lg:flex-row mb-4"
      >
        <div class="mb-6 md:mb-0 sm:w-1/4 h-auto">
          <p
            class="mt-32 text-left gt-walsheim-regular text-grey text-sm opacity-50 hidden lg:block"
          >
            © StoriesTV
          </p>
        </div>
        <div class="sm:w-1/4 h-auto sm:mt-0 mt-8">
          <div class="gt-walsheim-medium text-lg text-grey-darkest mb-4">
            StoriesTV
          </div>
          <ul class="list-reset leading-normal cursor-pointer">
            <li class="mb-4 md:mb-2">
              <a
                class="link open-sans-regular text-grey-darker hover-link"
                href="https://apps.apple.com/us/app/storiestv/id1563232866"
                target="_blank"
                rel="noopener noreferrer"
                >Download the iOS login app</a
              >
            </li>
          </ul>
        </div>
        <div class="sm:w-1/4 h-auto mt-8 lg:mt-0">
          <div class="gt-walsheim-medium text-lg text-grey-darkest mb-4">
            Help
          </div>
          <ul class="list-reset leading-normal cursor-pointer">
            <li class="mb-4 md:mb-2">
              <a
                class="link open-sans-regular text-grey-darker hover-link"
                href="https://storiestvsupport.web.app/PrivacyPolicy.txt"
                target="_blank"
                rel="noopener noreferrer"
                >Privacy policy</a
              >
            </li>
          </ul>
        </div>
        <div>
          <transition appear name="fade">
            <div class="mt-12 mt-4 lg:mt-0">
              <a
                class="opacity-100 inline-block w-8 mr-6 md:mr-4 grow"
                href="https://t.me/StoriesTVSupport"
                target="_blank"
                rel="noopener noreferrer"
                title="GitHub"
              >
                <img
                  alt="tg Icon"
                  class="w-8"
                  src="@/assets/svg/Telegram_logo.svg"
                />
              </a>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
